"use strict";

import _get from "/data/source/itapps/trunk/dapp.coin.skyland2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _classCallCheck from "/data/source/itapps/trunk/dapp.coin.skyland2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/source/itapps/trunk/dapp.coin.skyland2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/data/source/itapps/trunk/dapp.coin.skyland2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/source/itapps/trunk/dapp.coin.skyland2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/data/source/itapps/trunk/dapp.coin.skyland2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { arrayify, hexlify } from "@ethersproject/bytes";
import { Coder } from "./abstract-coder";
export var DynamicBytesCoder = /*#__PURE__*/function (_Coder) {
  function DynamicBytesCoder(type, localName) {
    _classCallCheck(this, DynamicBytesCoder);
    return _callSuper(this, DynamicBytesCoder, [type, type, localName, true]);
  }
  _inherits(DynamicBytesCoder, _Coder);
  return _createClass(DynamicBytesCoder, [{
    key: "encode",
    value: function encode(writer, value) {
      value = arrayify(value);
      var length = writer.writeValue(value.length);
      length += writer.writeBytes(value);
      return length;
    }
  }, {
    key: "decode",
    value: function decode(reader) {
      return reader.readBytes(reader.readValue().toNumber());
    }
  }]);
}(Coder);
export var BytesCoder = /*#__PURE__*/function (_DynamicBytesCoder) {
  function BytesCoder(localName) {
    _classCallCheck(this, BytesCoder);
    return _callSuper(this, BytesCoder, ["bytes", localName]);
  }
  _inherits(BytesCoder, _DynamicBytesCoder);
  return _createClass(BytesCoder, [{
    key: "decode",
    value: function decode(reader) {
      return reader.coerce(this.name, hexlify(_get(_getPrototypeOf(BytesCoder.prototype), "decode", this).call(this, reader)));
    }
  }]);
}(DynamicBytesCoder);